// src/features/tenants/hooks/useActivateTenant.ts
//
// Submission seam for the "فعال کردن تننت" flow (reverse of Suspend).
// Owns loading/error state around activateTenant API call — same
// shape as useSuspendTenant.

import { useState } from 'react';

import { activateTenant } from '../api/tenants.api';

export function useActivateTenant() {
  const [activating, setActivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(id: string) {
    setActivating(true);
    setError(null);

    try {
      const tenant = await activateTenant(id);
      return tenant;
    } catch (err) {
      setError('خطا در فعال‌سازی تننت. لطفاً دوباره تلاش کنید.');
      throw err;
    } finally {
      setActivating(false);
    }
  }

  function resetError() {
    setError(null);
  }

  return {
    submit,
    activating,
    error,
    resetError,
  };
}
